const zh = {
  nav: {
    home: '首页',
    category: '分类浏览',
    about: '关于我们',
    search: '搜索写真...',
  },
  hero: {
    title: 'mm131 高清写真资源一站直达',
    subtitle: '海量精选写真套图 · 热门模特图集 · 时尚摄影资源',
    cta: '立即浏览',
    secondary: '了解更多',
  },
  home: {
    hotAlbums: '热门推荐',
    hotAlbumsDesc: '精选最受欢迎的写真套图，每周更新',
    viewAlbum: '查看套图',
    categoryNav: '分类导航',
    categoryNavDesc: '按类别探索你喜爱的写真风格',
    latestArticles: '最新套图',
    latestArticlesDesc: '每日更新，精彩不容错过',
    readMore: '阅读全文',
    views: '次浏览',
    faqTitle: '常见问题',
    faqDesc: '关于 mm131 你想知道的一切',
    ctaTitle: '收藏 mm131，精彩随时直达',
    ctaDesc: '将 mm131 设为浏览器首页，第一时间获取最新写真资源',
    ctaButton: '收藏本页',
    allCategories: '查看全部分类',
    allArticles: '浏览更多套图',
  },
  category: {
    title: '分类浏览',
    desc: '按写真风格和主题分类，快速找到你喜爱的内容',
    allCategories: '全部分类',
    articleCount: '篇套图',
    noArticles: '该分类暂无内容，请浏览其他分类',
    backToCategories: '返回分类列表',
  },
  article: {
    backToList: '返回列表',
    author: '作者',
    publishDate: '发布时间',
    views: '阅读量',
    tags: '标签',
    relatedArticles: '相关推荐',
    readMore: '阅读全文',
  },
  about: {
    title: '关于 mm131',
    subtitle: '国内领先的高清写真图库平台',
    brandIntro: '品牌介绍',
    brandDesc1: 'mm131 成立于2015年，是国内最早专注于高清美女写真资源整合的平台之一。经过近十年的发展，我们已积累了超过十万套精选写真资源，涵盖性感写真、清纯美女、时尚街拍、私房摄影、日系写真、韩系风格等十余个分类。',
    brandDesc2: '我们秉承"发现美、记录美、分享美"的理念，致力于为广大摄影爱好者和视觉内容消费者提供最优质的写真图库服务。我们的编辑团队每日精选最新内容，确保平台的持续更新和内容品质。',
    brandDesc3: 'mm131 不仅是一个图库平台，更是一个连接摄影师、模特和用户的综合性社区。我们定期举办线上线下摄影活动，促进行业交流与发展。',
    reputation: '用户口碑',
    contactTitle: '联系我们',
    contactDesc: '如有任何问题或合作意向，欢迎通过以下方式与我们取得联系',
    email: '电子邮箱',
    emailValue: 'contact@mm131.com',
    phone: '联系电话',
    phoneValue: '400-888-1314',
    address: '公司地址',
    addressValue: '上海市浦东新区张江高科技园区博云路2号 mm131大厦',
    wechat: '微信公众号',
    wechatValue: 'mm131官方',
    weibo: '官方微博',
    weiboValue: '@mm131官方微博',
    businessHours: '工作时间',
    businessHoursValue: '周一至周五 9:00-18:00',
  },
  footer: {
    about: '关于我们',
    categories: '热门分类',
    links: '快速链接',
    contact: '联系方式',
    copyright: '© 2024 mm131. All rights reserved.',
    privacy: '隐私政策',
    terms: '服务条款',
    sitemap: '网站地图',
  },
  breadcrumb: {
    home: '首页',
    category: '分类浏览',
    about: '关于我们',
  },
  seo: {
    homeTitle: 'mm131官方入口·高清写真资源一站直达 | mm131写真图库',
    homeDesc: 'mm131是国内知名高清美女写真图库平台，提供海量精选写真套图、模特图集与时尚摄影资源。汇聚mm131最新内容导航、热门专辑推荐及快速访问入口，帮助用户第一时间找到所需高清写真内容。',
    homeKeywords: 'mm131,mm131写真,mm131图库,mm131高清美女,mm131最新套图,mm131模特图集,mm131官网入口',
    categoryTitle: 'mm131写真分类浏览 - 高清美女写真按风格筛选 | mm131图库',
    categoryDesc: 'mm131写真分类浏览页面，按性感写真、清纯美女、时尚街拍、私房摄影、日系写真、韩系风格等分类快速筛选高清写真资源。',
    aboutTitle: '关于mm131 - 品牌介绍与联系方式 | mm131写真图库',
    aboutDesc: '了解mm131品牌故事与发展历程。mm131是国内领先的高清美女写真图库平台，提供品牌介绍、用户口碑及联系方式。',
  },
};

export default zh;